var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./EditRegionModal.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-0608d0d8!../../node_modules/vue-loader/lib/selector?type=template&index=0!./EditRegionModal.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/modals/EditRegionModal.vue
// module id = 441
// module chunks = 1